import moment from "moment";

import { EnumRecurrenceType } from "@/Appointments/Models/EnumRecurrenceType";
import { AppointmentEditModel, IAppointmentEditModel } from "@/Appointments/Models/UI/IAppointmentEditModel";
import { CalendarStore } from "@/Appointments/Stores/CalendarStore";
import { PhoneNumber } from "@/Common/Api/Contacts/Dto/PhoneNumber";
import { FlatLookupView } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupView";
import { ArrayHelper } from "@/Common/Helpers/ArrayHelper";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { PatientHelper } from "@/Common/Helpers/PatientHelper";
import { Email } from "@/Common/Models/Contacts/Email";
import { Guid } from "@/Common/Models/Guid";
import { Patient as MyleModelsPatientPatient } from "@/Common/Models/Patient/Patient";
import { OntarioPatientEnrollmentModel } from "@/Common/Models/Patient/PatientEnrollment/Ontario/OntarioPatientEnrollmentModel";
import { IPatientCreationModel } from "@/Common/Models/Patient/UI/IPatientCreationModel";
import { Person } from "@/Common/Models/Person/Person";
import { QuestionnaireStatusInfo } from "@/Common/Models/Questionnaires/QuestionnaireStatusInfo";
import { ServiceModel } from "@/Common/Models/Services/ServiceModel";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { PersonDropdownItem } from "@/Common/Models/UI/Inputs/PersonDropdownItem";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";

class AppointmentEditHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_Patient_OnChange, this.onPatientChange);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_Patient_TextChange, this.onPatientTextChange);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_Patient_OnClear, this.patientOnClear);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_Intervenors_OnChange, this.onIntervenorChange);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_Subject_onClearSelectedService, this.onClearSelectedService);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_Subject_onServiceSelected, this.onServiceSelected);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_Subject_OnChange, this.subjectChange);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_StartDate_Set, this.startDateChange);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_StartTime_Set, this.startTimeChange);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_EndTime_Set, this.endDateChange);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_Site_OnChange, this.siteChange);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_Room_OnChange, this.roomChange);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_State_OnChange, this.stateChange);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_CanadianTriageAndAcuityScore_OnChange, this.CanadianTriageAndAcuityScoreChange);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_Recurrence_OnChange, this.recurrenceChange);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_Recurrence_EndDate_Set, this.recurrenceDateChange);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_Notes_OnChange, this.notesChange);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_Referrals_OnChange, this.onReferralChange);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_Referrals_OnTextChange, this.onReferalTextChange);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_ReferralPhone_OnChange, this.referralPhoneNumberChange);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_Referrals_OnClear, this.referralsClear);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_OnCancel, this.onCancel);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_OnSave, this.onSave);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_GroupConfirmSave, this.save);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_OnSaveAndOpen, this.onSaveAndOpen);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_Copy, this.onCopy);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_Cut, this.onCut);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_Paste, this.onPaste);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_PrintLabel, this.onPrintLabel);
        this.RegisterOperation(LocalOperations.Calendar.Checkbox_Change, this.onCheckboxChange);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_NewPatientClick, this.onCreatePatientFile);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_LinkPatientPortalClick, this.onLinkPatientPortal);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_LinkPatientPortal_Cancel, this.onCancelLinkPatientPortal);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_LinkPatientPortal_CreatedOrAttached, this.onLinkPatientPortal_PatientCreatedOrAttached);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_OnCompleteRecall, this.onCompleteRecall);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_NewPatient_Cancel, this.newPatient_Cancel);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_NewPatient_Save, this.newPatient_Save);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_IsPaidCheck, this.isPaidCheck);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_CancelPortalPatientFetch, this.cancelPortalPatientFetch);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_Duplicate_AssociatePatient, this.duplicateAssociatePatient);
        this.RegisterOperation(LocalOperations.Misc.MyleApp_Container_Click, this.onOverlayClick, false);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_IsTeleconsultationCheck, this.isTeleconsultationCheck);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_IsContactPointNotificationChecked, this.isContactPointNotificationChecked);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_IsSendNotificationsToAllPersonalContactsChecked, this.isSendNotificationsToAllPersonalContactChecked);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_Questionnaire_OnChange, this.onQuestionnaireChange);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_Questionnaire_OnClick, this.onQuestionnaireClick);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_Questionnaire_OnSubmitted, this.onQuestionnaireSubmitted);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_LinkThirdPartyPatientClick, this.onLinkThirdPartyPatient);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_LinkThirdPartyPatientSuccess, this.onLinkThirdPartyPatientSuccess);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_LinkThirdPartyPatientCancel, this.onLinkThirdPartyPatientCancel);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_SetOntarioEnrollmentPatientBanner, this.setOntarioEnrollmentPatientBanner);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_PrintCertificate, this.onPrintCertificate);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_OnOpen, this.onOpen);
        this.RegisterOperation(LocalOperations.Calendar.AppointmentEdit_Tab_OnChange, this.onTabChange);
    }

    private isPaidCheck(request: LocalEvent, store: CalendarStore): void {
        let isPaid = store.appointmentEditModel.get("IsPaid");

        store.appointmentEditModel = store.appointmentEditModel.set("IsPaid", !isPaid);
    }

    private isTeleconsultationCheck(request: LocalEvent, store: CalendarStore): void {
        let isTeleconsultation = store.appointmentEditModel.get("IsTeleconsultation");
        store.appointmentEditModel = store.appointmentEditModel.set("IsTeleconsultation", !isTeleconsultation);

        store.refreshNotifyPatientStatus(true);
    }

    private onPatientChange(request: LocalEvent, store: CalendarStore): void {
        let patientItem = request.Get<PersonDropdownItem>("value");

        let previousPatientItems = store.appointmentEditModel.get("SelectedPatient").toArray();

        let list: Person[] = [];
        if (previousPatientItems && previousPatientItems.indexOf(patientItem.Item) == -1)
            list.push(patientItem.Item);

        store.appointmentEditModel = store.appointmentEditModel.set("SelectedPatient", Immutable.List(list));
        if (list.length <= 0)
            store.appointmentEditModel = store.appointmentEditModel.set("SelectedPatientId", null);
        else {
            let patientId = list[0].ContactId;
            store.appointmentEditModel = store.appointmentEditModel.set("SelectedPatientId", patientId);
            if (patientId === store.appointmentEditModel.get("OriginalPatientContactId"))
                store.appointmentEditModel = store.appointmentEditModel.set("Questionnaire", store.appointmentEditModel.get("OriginalQuestionnaire"));
        }

        // reload patient info
        calendarStore.calendarActions.LoadPatient(store.appointmentEditModel);
    }

    private onPatientTextChange(request: LocalEvent, store: CalendarStore): void {
        let textString = request.Get<string>("value");
        store.appointmentEditModel = store.appointmentEditModel.set("PatientSearchString", textString);

        if (!textString && store.appointmentEditModel.get("IsPrintCertificateOnSave"))
            store.appointmentEditModel = store.appointmentEditModel.set("IsPrintCertificateOnSave", false);
    }

    private patientOnClear(request: LocalEvent, store: CalendarStore): void {
        var appt = store.appointmentEditModel.get("Appointment");

        if (appt != null) {
            appt.PatientLastName = "";
            appt.PatientPreferredName = "";
            appt.PatientFirstName = "";
            store.appointmentEditModel = store.appointmentEditModel
                .delete("Appointment")
                .set("Appointment", appt)
                .set("SelectedPatient", Immutable.List([]))
                .set("SelectedPatientId", null)
                .set("ContactPointNotificationList", [].toImmutable())
                .set("HasNotificationContactPointSpecified", false);

            if (store.appointmentEditModel.get("Questionnaire")?.HasResult)
                store.appointmentEditModel = store.appointmentEditModel
                    .set("Questionnaire", store.appointmentEditModel.get("Questionnaire").newInstance());

            if (store.appointmentEditModel.get("IsPrintCertificateOnSave") && IsNullOrWhiteSpace(store.appointmentEditModel.get("PatientSearchString")))
                store.appointmentEditModel = store.appointmentEditModel.set("IsPrintCertificateOnSave", false);
        }

        store.SetDefaultPatientBannerModel();
        store.refreshNotifyPatientStatus();
    }

    private onIntervenorChange(request: LocalEvent, store: CalendarStore): void {
        let intervenor = request.Get<PersonDropdownItem>("value");

        if (intervenor == null || intervenor.Item == null)
            return;

        let selectedIntervenors: Person[] = store.appointmentEditModel.get("SelectedIntervenors").toArray();

        if (selectedIntervenors.indexOf(intervenor.Item) > -1)
            selectedIntervenors = selectedIntervenors.filter(x => x.ContactId != intervenor.Item.ContactId);
        else
            selectedIntervenors.push(intervenor.Item);

        store.appointmentEditModel = store.appointmentEditModel.set("SelectedIntervenors", Immutable.List(selectedIntervenors));
    }

    private onClearSelectedService(request: LocalEvent, store: CalendarStore): void {
        store.appointmentEditModel = store.appointmentEditModel
            .set("Subject", "")
            .set("SelectedSubjectService", null)
            .set("SelectedSubjectServiceId", "")
            .set("SelectedSubjectResourceDefinitionId", "")
            .set("IsTeleconsultation", false);

        let appointmentDate = store.appointmentEditModel.get("StartTime");
        let isBeforeAppointment = moment().isBefore(appointmentDate, "day");
        let isNewAppointment = store.appointmentEditModel.get("IsNewAppointment");
        if (isBeforeAppointment || isNewAppointment)
            store.appointmentEditModel = store.appointmentEditModel.set("Questionnaire", null);

        store.refreshNotifyPatientStatus(true);
    }

    private onServiceSelected(request: LocalEvent, store: CalendarStore): void {
        let serviceModel = request.Get<ServiceModel>("serviceModel");
        let questionnaireStatusInfo = serviceModel.ServiceDefinitionModel.Model.QuestionnaireId
            && new QuestionnaireStatusInfo({
                QuestionnaireInstanceId: GuidHelper.Empty(),
                QuestionnaireId: serviceModel.ServiceDefinitionModel.Model.QuestionnaireId
            });
        let originalQuestionnaire = store.appointmentEditModel.get("OriginalQuestionnaire");

        store.appointmentEditModel = store.appointmentEditModel
            .set("SelectedSubjectService", serviceModel)
            .set("SelectedSubjectServiceId", serviceModel.ServiceID)
            .set("SelectedSubjectResourceDefinitionId", serviceModel.ServiceDefinitionModel.Model.Id)
            .set("EndTime", moment(store.appointmentEditModel.get("StartTime")).add(serviceModel.ServiceDefinitionModel.Model.DefaultDuration / (60 * 10000000), "minutes").toDate())
            .set("IsTeleconsultation", serviceModel.ServiceDefinitionModel.Model.IsTeleconsultation)
            .set("Questionnaire", (!originalQuestionnaire || !originalQuestionnaire.HasResult) ? questionnaireStatusInfo : originalQuestionnaire);

        store.refreshNotifyPatientStatus(true);
    }

    private onTabChange(request: LocalEvent, store: CalendarStore): void {
        const isCalendarEventTab = request.Get<boolean>("isCalendarEventTab");
        store.appointmentEditModel = store.appointmentEditModel.set("IsCalendarEventTab", isCalendarEventTab);
    }

    private subjectChange(request: LocalEvent, store: CalendarStore): void {
        let subject = request.Get<string>("customSubject");
        store.appointmentEditModel = store.appointmentEditModel.set("Subject", subject);
    }

    private startDateChange(request: LocalEvent, store: CalendarStore): void {
        let date = request.Get<Date>("value");

        let currentStartTimeHours = store.appointmentEditModel.get("StartTime").getHours();
        let currentStartTimeMinutes = store.appointmentEditModel.get("StartTime").getMinutes();
        let currentEndTimeHours = store.appointmentEditModel.get("EndTime").getHours();
        let currentEndTimeMinutes = store.appointmentEditModel.get("EndTime").getMinutes();

        let newStartTime = moment(date).set("hours", currentStartTimeHours);
        newStartTime = newStartTime.set("minutes", currentStartTimeMinutes);

        let newEndTime = moment(date).set("hours", currentEndTimeHours);
        newEndTime = newEndTime.set("minutes", currentEndTimeMinutes);

        store.appointmentEditModel = store.appointmentEditModel.set("StartTime", newStartTime.toDate());
        store.appointmentEditModel = store.appointmentEditModel.set("EndTime", newEndTime.toDate());

        let previousQuestionnaireStatusInfo = store.appointmentEditModel.get("OriginalQuestionnaire");
        let isSameDay = moment(date).isSame(store.appointmentEditModel.get("OriginalStartTime"), "day");
        store.appointmentEditModel = store.appointmentEditModel.set(
            "Questionnaire",
            isSameDay
                ? previousQuestionnaireStatusInfo
                : previousQuestionnaireStatusInfo?.newInstance()
        );

        this.validateDate(store);
    }

    private startTimeChange(request: LocalEvent, store: CalendarStore): void {
        let date = request.Get<Date>("value");
        let currentStartDate = store.appointmentEditModel.get("StartTime");
        let hoursSelected = date.getHours();
        let minutesSelected = date.getMinutes();

        currentStartDate.setHours(hoursSelected);
        currentStartDate.setMinutes(minutesSelected);

        store.appointmentEditModel = store.appointmentEditModel.set("StartTime", currentStartDate);
        this.validateDate(store);
    }

    private endDateChange(request: LocalEvent, store: CalendarStore): void {
        let date = request.Get<Date>("value");
        let currentEndDate = store.appointmentEditModel.get("EndTime");
        let hoursSelected = date.getHours();
        let minutesSelected = date.getMinutes();

        currentEndDate.setHours(hoursSelected);
        currentEndDate.setMinutes(minutesSelected);

        store.appointmentEditModel = store.appointmentEditModel.set("EndTime", currentEndDate);
        this.validateDate(store);
    }

    private validateDate(store: CalendarStore): void {
        let start = store.appointmentEditModel.get("StartTime");
        let end = store.appointmentEditModel.get("EndTime");
        store.appointmentEditModel = store.appointmentEditModel.set("IsDateInvalid", (end <= start));
    }

    private siteChange(request: LocalEvent, store: CalendarStore): void {
        let siteId = request.Get<Guid>("value");

        const appointmentSelectedIntervenorsContactIds = store.appointmentEditModel.get("SelectedIntervenors").map(p => p.ContactId);
        const cliniciansFromAppointment = cacheStore.EmployeeCache.filter(p => appointmentSelectedIntervenorsContactIds.includes(p.Contact_id));
        const intervenorsWithAllowedSite = cliniciansFromAppointment.filter(p => p.AssociatedSites.includes(siteId)).map(p => p.Contact_id);

        const newSelectedIntervenors = store.appointmentEditModel.get("SelectedIntervenors").filterImmutable(p => intervenorsWithAllowedSite.includes(p.ContactId));

        store.appointmentEditModel = store.appointmentEditModel
            .set("SelectedSiteId", siteId)
            .set("Rooms", store.GetRoomsToDisplay())
            .set("RoomsDisplayText", Immutable.List(store.GetRoomsToDisplay().toArray().map(x => x.Name)))
            .set("SelectedIntervenors", newSelectedIntervenors);

        let employeeId = store.appointmentEditModel.get("AppointmentIntervenor").ContactFacetId;
        let employee = cacheStore.GetEmployeeByContactFacetId(employeeId);
        store.appointmentEditModel = store.appointmentEditModel.set("DefaultSubjects", calendarStore.GetDefaultServicesBySiteAndEmployee(siteId, employee));
    }

    private roomChange(request: LocalEvent, store: CalendarStore): void {
        let roomtext = request.Get<string>("value");
        store.appointmentEditModel = store.appointmentEditModel.set("RoomText", roomtext);
    }

    private stateChange(request: LocalEvent, store: CalendarStore): void {
        let stateCode = request.Get<string>("value");
        store.appointmentEditModel = store.appointmentEditModel.set("SelectedAppointmentStateCode", stateCode);

        const cancelledStateCodes = ["NOSHOW", "CANCELED", "CANCELLED BY PATIENT"];
        if (cancelledStateCodes.any(x => x === store.appointmentEditModel.get("SelectedAppointmentStateCode")))
            store.appointmentEditModel = store.appointmentEditModel.set("IsPrintCertificateOnSave", false);
    }

    private recurrenceChange(request: LocalEvent, store: CalendarStore): void {
        let typeCode = request.Get<EnumRecurrenceType>("value");
        store.appointmentEditModel = store.appointmentEditModel.set("SelectedRecurrenceType", typeCode);
    }

    private CanadianTriageAndAcuityScoreChange(request: LocalEvent, store: CalendarStore): void {
        const score = request.Get<number>("value");
        store.appointmentEditModel = store.appointmentEditModel.set("SelectedCanadianTriageAndAcuityScore", score);
    }

    private recurrenceDateChange(request: LocalEvent, store: CalendarStore): void {
        let date = request.Get<Date>("value");
        store.appointmentEditModel = store.appointmentEditModel.set("RecurrenceEndDate", date);
    }

    private notesChange(request: LocalEvent, store: CalendarStore): void {
        let notes = request.Get<string>("value");
        store.appointmentEditModel = store.appointmentEditModel.set("Notes", notes);
    }

    private onReferralChange(request: LocalEvent, store: CalendarStore): void {
        const referralDoctor = request.Get<PersonDropdownItem>("value").Item;
        const shouldSaveAsCustomReferral = request.Get<boolean>("shouldSaveAsCustomReferral") ?? false;

        store.appointmentEditModel = store.appointmentEditModel
            .set("ReferralDoctors", Immutable.List([referralDoctor]))
            .set("ReferralPhoneNumber", referralDoctor.PreferedPhone)
            .set("ReferralOrganizationRuleId", referralDoctor.OrganizationRuleId);

        if (shouldSaveAsCustomReferral) {
            store.appointmentEditModel = store.appointmentEditModel.set(
                "ReferralDoctorSearchString",
                `${referralDoctor.LastName}, ${referralDoctor.FirstName} (${referralDoctor.Licence})`
            );
        }
        else {
            store.appointmentEditModel = store.appointmentEditModel.set("ReferralDoctorId", referralDoctor.Licence);
        }
    }

    private onReferalTextChange(request: LocalEvent, store: CalendarStore): void {
        let textString = request.Get<string>("value");
        store.appointmentEditModel = store.appointmentEditModel.set("ReferralDoctorSearchString", textString);
    }

    private referralsClear(request: LocalEvent, store: CalendarStore): void {
        store.appointmentEditModel = store.appointmentEditModel
            .set("ReferralDoctorSearchString", "")
            .set("ReferralPhoneNumber", "")
            .set("ReferralDoctors", Immutable.List([]))
            .set("ReferralDoctorId", "")
            .set("ReferralOrganizationRuleId", "");
    }

    private referralPhoneNumberChange(request: LocalEvent, store: CalendarStore): void {
        let phone = request.Get<string>("value");
        store.appointmentEditModel = store.appointmentEditModel.set("ReferralPhoneNumber", phone);
    }

    private onCheckboxChange(request: LocalEvent, store: CalendarStore): void {
        let target = request.Get<CheckboxTarget>("target");
        let checked = request.Get<boolean>("checked");

        switch (target) {
            case CheckboxTarget.Myle_Calendar_Appointment_IsPrintLabelOnSave:
                store.appointmentEditModel = store.appointmentEditModel.set("IsPrintLabelOnSave", checked);
                break;
            case CheckboxTarget.Myle_Calendar_Appointment_IsPrintCertificateOnSave:
                store.appointmentEditModel = store.appointmentEditModel.set("IsPrintCertificateOnSave", checked);
                break;
            case CheckboxTarget.Myle_Calendar_Appointment_NotifyPatient:

                if (checked || !store.appointmentEditModel.get("Questionnaire"))
                    store.setNotificationsByNotifyPatientStatus(checked);

                store.appointmentEditModel = store.appointmentEditModel
                    .set("NotifyPatient", checked)
                    .set("NotifyPatientManualOverride", checked);

                if (checked)
                    store.refreshNotifyPatientStatus();
                break;
            default:
                break;
        }
    }

    private onCancel(request: LocalEvent, store: CalendarStore): void {
        store.SetDefaultEditAppointmentModel();
        store.SetDefaultPatientModel();
        store.SetDefaultPatientBannerModel();
        store.calendarModel = store.calendarModel.set("IsEditAppointmentDialogVisible", false);
        store.calendarModel = store.calendarModel.set("ShowComboAppointmentModificationPopup", false);
        store.appointmentEditModel = store.appointmentEditModel.set("Subject", "");

        sessionStore.hideGlobalOverlay();
    }

    private onOverlayClick(request: LocalEvent, store: CalendarStore): void {
        if (store.calendarModel.get("IsEditAppointmentDialogVisible") === true &&
            !AppointmentEditModel.hasCoreAppointmentDataChanged(store.appointmentEditModel)) {
            this.onCancel(request, calendarStore);

            store.EmitChangeToListeners();
        }
    }

    private checkIfStateChangedWarrantsWarning(newAppState: string, store: CalendarStore): boolean {
        var oldAppointment = store.appointmentEditModel.get("Appointment");
        if (oldAppointment.AppointmentComboId == null || isNaN(oldAppointment.ComboId)) // Can't trust only ApppointmentGroupId to garanti there is nore then 1 appointment in the group... Portal Appointment all have GroupId
            return false;

        var oldStateLookupId = oldAppointment.AppointmentStateLookupId;
        var newState: FlatLookupView = ArrayHelper.Find(store.appointmentEditModel.get("AppointmentStates").toArray(), (x: FlatLookupView) => x.LookupCode == store.appointmentEditModel.get("SelectedAppointmentStateCode"));

        var cancelledLookup = cacheStore.FindLookupByLookupCode("CANCELED", "SITEMGMT.APPOINTMENTS.STATE");
        var cancelledByPatientLookup = cacheStore.FindLookupByLookupCode("CANCELLED BY PATIENT", "SITEMGMT.APPOINTMENTS.STATE");

        if (
            (oldStateLookupId != newState.LookupID && (newState.LookupID == cancelledLookup.LookupID || newState.LookupID == cancelledByPatientLookup.LookupID))
            ||
            ((oldStateLookupId == cancelledLookup.LookupID || oldStateLookupId == cancelledByPatientLookup.LookupID) && newState.LookupID != cancelledLookup.LookupID && newState.LookupID != cancelledByPatientLookup.LookupID))
            return true;
        else
            return false;
    }

    private onSave(request: LocalEvent, store: CalendarStore): void {
        let appState = store.appointmentEditModel.get("SelectedAppointmentStateCode");

        if (this.checkIfStateChangedWarrantsWarning(appState, store)) {
            store.calendarModel = store.calendarModel.set("ShowComboAppointmentModificationPopup", true);
            store.calendarModel = store.calendarModel.set("IsEditAppointmentDialogVisible", false);
        }
        else {
            this.save(request, store, false);
        }
    }

    private onSaveAndOpen(request: LocalEvent, store: CalendarStore): void {
        let appState = store.appointmentEditModel.get("SelectedAppointmentStateCode");

        if (this.checkIfStateChangedWarrantsWarning(appState, store)) {
            store.calendarModel = store.calendarModel.set("ShowComboAppointmentModificationPopup", true);
            store.calendarModel = store.calendarModel.set("IsEditAppointmentDialogVisible", false);
        }
        else {
            this.save(request, store, true);
        }
    }

    private save(request: LocalEvent, store: CalendarStore, openAfterSave: boolean = false): void {
        // forego doublebooking check if we are cancelling an appointment
        let appState = store.appointmentEditModel.get("SelectedAppointmentStateCode");
        store.isSaving = true;

        store.calendarModel = store.calendarModel.set("ShowComboAppointmentModificationPopup", false);
        store.calendarModel = store.calendarModel.set("OpenPatientProfileAfterSave", openAfterSave);

        if (appState.toUpperCase() != "CANCELED" && appState.toUpperCase() != "CANCELLED BY PATIENT") {
            store.calendarActions.CheckForDoubleBooking(store);
        }
        else {
            store.calendarActions.SaveAppointment(store);
        }
    }

    private onCopy(): void {
        this.CopyCutAppointment(true);
    }

    private onCut(): void {
        this.CopyCutAppointment(false);
    }

    public CopyCutAppointment(isCopy: boolean): void {
        calendarStore.calendarModel = calendarStore.calendarModel.delete("AppointmentEditForCopy");

        var currentAppointmentEditModel = calendarStore.appointmentEditModel;
        if (!isCopy)
            currentAppointmentEditModel = currentAppointmentEditModel.set("IsFromCutAppointment", true);

        currentAppointmentEditModel = currentAppointmentEditModel.set("SelectedPatientId", currentAppointmentEditModel.get("SelectedPatientId")); // to get a copy

        let duration = moment(calendarStore.appointmentEditModel.get("EndTime")).diff(moment(calendarStore.appointmentEditModel.get("StartTime")), "minutes");
        currentAppointmentEditModel = currentAppointmentEditModel.set("DurationForCutAndPaste", duration);

        calendarStore.calendarModel = calendarStore.calendarModel.set("AppointmentEditForCopy", currentAppointmentEditModel);
        calendarStore.calendarModel = calendarStore.calendarModel.set("IsEditAppointmentDialogVisible", false);

        sessionStore.hideGlobalOverlay();
    }

    private onPaste(): void {
        var modelToPaste = calendarStore.calendarModel.get("AppointmentEditForCopy");

        // Has Something to Paste
        if (modelToPaste) {
            // cannot paste appointment edit into itself...
            if (modelToPaste.get("Appointment").AppointmentId !== calendarStore.appointmentEditModel.get("Appointment").AppointmentId) {
                let currentEditedAppointment = this.CloneIntoAppointmentEditModel(modelToPaste);
                currentEditedAppointment = currentEditedAppointment.set("Notes", `${cacheStore.GetString("CopiedFromLabel")} ${moment(modelToPaste.get("StartTime")).format("YYYY-MM-DD HH:mm")}`);

                // Update or Create?
                currentEditedAppointment = currentEditedAppointment.set("IsNewAppointment", true); // Create New
                if (modelToPaste.get("IsFromCutAppointment")) {
                    currentEditedAppointment = currentEditedAppointment.set("IsNewAppointment", false); // Update
                    currentEditedAppointment = currentEditedAppointment.set("Notes", `${cacheStore.GetString("CutFromLabel")} ${moment(modelToPaste.get("StartTime")).format("YYYY-MM-DD HH:mm")}`);
                }

                // if the appoint we are cutting was previously a predefined appointment, recreate the old predefined appointment at the correct time
                if (modelToPaste.get("IsFromCutAppointment")) {
                    var underlyingAppointment = currentEditedAppointment.get("Appointment");
                    currentEditedAppointment = currentEditedAppointment.set("Appointment", underlyingAppointment);
                }

                if (currentEditedAppointment.get("SelectedPatientId"))
                    currentEditedAppointment = currentEditedAppointment.set("PatientSearchString", null);

                if (!currentEditedAppointment.get("IsFromCutAppointment")) {
                    const underlyingAppointment = currentEditedAppointment.get("Appointment");
                    underlyingAppointment.IsSynchronized = null;
                    underlyingAppointment.IsPatientNotificationsEnabled = false;

                    currentEditedAppointment = currentEditedAppointment
                        .set("Appointment", underlyingAppointment)
                        .set("NotifyPatientDisabled", !currentEditedAppointment.get("SelectedPatientId"))
                        .set("NotifyPatientManualOverride", !!currentEditedAppointment.get("SelectedPatientId") && !!currentEditedAppointment.get("NotifyPatient"));
                }

                if (currentEditedAppointment.get("PatientSearchString")?.trim() || currentEditedAppointment.get("SelectedPatient").size > 0)
                    currentEditedAppointment = currentEditedAppointment.set("IsCalendarEventTab", false);

                // refresh client subjects
                let currentEmployee = calendarStore.appointmentEditModel.get("AppointmentIntervenor").EmployeeModel;
                let defaultServices = calendarStore.GetDefaultServicesBySiteAndEmployee(currentEmployee.ActiveSiteId, currentEmployee);
                currentEditedAppointment = currentEditedAppointment.set("DefaultSubjects", defaultServices);

                // reset duration of appointment
                var newEndTime = moment(calendarStore.appointmentEditModel.get("StartTime")).add(modelToPaste.get("DurationForCutAndPaste"), "minutes").toDate();
                currentEditedAppointment = currentEditedAppointment.set("EndTime", newEndTime);

                // Set Model
                calendarStore.appointmentEditModel = currentEditedAppointment;

                // Reload Patient
                calendarStore.calendarActions.LoadPatient(calendarStore.appointmentEditModel);
            }
        }
    }

    public CloneIntoAppointmentEditModel(from: IAppointmentEditModel): IAppointmentEditModel {
        let currentEditedAppointment = calendarStore.appointmentEditModel;
        currentEditedAppointment = currentEditedAppointment
            .set("Appointment", from.get("Appointment"))
            .set("SelectedPatientId", from.get("SelectedPatientId"))
            .set("SelectedPatient", from.get("SelectedPatient"))
            .set("PatientFamilyDoctorId", from.get("PatientFamilyDoctorId"))
            .set("PatientFamilyDoctor", from.get("PatientFamilyDoctor"))
            .set("SelectedRoomId", from.get("SelectedRoomId"))
            .set("Rooms", from.get("Rooms"))
            .set("RoomText", from.get("RoomText"))
            .set("SelectedSiteId", from.get("SelectedSiteId"))
            .set("Sites", from.get("Sites"))
            .set("AppointmentStates", from.get("AppointmentStates"))
            .set("Intervenors", from.get("Intervenors"))
            .set("ReferralDoctors", from.get("ReferralDoctors"))
            .set("ReferralDoctorId", from.get("ReferralDoctorId"))
            .set("ReferralOrganizationRuleId", from.get("ReferralOrganizationRuleId"))
            .set("ReferralDoctorSearchString", from.get("ReferralDoctorSearchString"))
            .set("ReferralPhoneNumber", from.get("ReferralPhoneNumber"))
            .set("RecurrenceTypes", from.get("RecurrenceTypes"))
            .set("IsFromCutAppointment", from.get("IsFromCutAppointment"))
            .set("NotifyPatient", from.get("NotifyPatient"))
            .set("NotifyPatientDisabled", from.get("NotifyPatientDisabled"))
            .set("PatientSearchString", from.get("PatientSearchString"))
            .set("Subject", from.get("Subject"))
            .set("DefaultSubjects", from.get("DefaultSubjects"))
            .set("SelectedSubjectService", from.get("SelectedSubjectService"))
            .set("SelectedSubjectResourceDefinitionId", from.get("SelectedSubjectResourceDefinitionId"))
            .set("IsTeleconsultation", from.get("IsTeleconsultation"))
            .set("SelectedAppointmentStateCode", cacheStore.FindLookupByLookupCode("UNCONFIRMED").LookupCode)
            .set("SelectedCanadianTriageAndAcuityScore", from.get("SelectedCanadianTriageAndAcuityScore"));

        // If primary intervenor doesn't provide the service we paste, we remove the service, otherwise we take the ServiceId of primary intervenor service
        const currentEmployee = calendarStore.appointmentEditModel.get("AppointmentIntervenor").EmployeeModel;
        const currentEmployeeService = currentEmployee.ServicesIDsOffered.firstOrDefault(service => service.DefId == from.get("SelectedSubjectResourceDefinitionId"));
        if (currentEmployeeService) {
            currentEditedAppointment = currentEditedAppointment.set("SelectedSubjectServiceId", currentEmployeeService.Id);
        }
        else {
            // If primary intervenor does not have same service definition, reset to empty (so it will be saved as new intervenor's adhoc service)
            currentEditedAppointment = currentEditedAppointment
                .set("SelectedSubjectServiceId", "")
                .set("SelectedSubjectService", null)
                .set("SelectedSubjectResourceDefinitionId", "");
        }

        // Copy/Merge Intervenors
        var pastedIntervenors = from.get("SelectedIntervenors").toArray();
        var newIntevernors = calendarStore.appointmentEditModel.get("SelectedIntervenors").toArray();
        var sameLength = pastedIntervenors.length == newIntevernors.length;
        var isSameIntervenor = sameLength && pastedIntervenors.some(x => newIntevernors.indexOf(x) >= 0);

        const pastedIntervenorsIds = pastedIntervenors.map(p => p.ContactId).distinct();
        const newIntervenorIds = newIntevernors.map(p => p.ContactId).distinct();

        const containsAllIds = newIntervenorIds.every(id => pastedIntervenorsIds.includes(id));
        if (containsAllIds) {
            currentEditedAppointment = currentEditedAppointment.set("SelectedIntervenors", from.get("SelectedIntervenors"));
        }

        if (!isSameIntervenor) {
            let currentSelectedSiteId = currentEditedAppointment.get("SelectedSiteId");
            let employee = currentEditedAppointment.get("AppointmentIntervenor").EmployeeModel;
            if (employee?.AssociatedSites.all(id => id !== currentSelectedSiteId)) {
                currentEditedAppointment = currentEditedAppointment
                    .set("DefaultSubjects", calendarStore.GetDefaultServicesBySiteAndEmployee(employee.ActiveSiteId, employee))
                    .set("SelectedSiteId", employee.ActiveSiteId);
            }
        }

        let previousQuestionnaireStatusInfo = from.get("Questionnaire");
        let isFromCutAppointment = from.get("IsFromCutAppointment");
        let isSameDay = moment(from.get("StartTime")).isSame(calendarStore.appointmentEditModel.get("StartTime"), "day");
        let hasSubmittedQuestionnaire = previousQuestionnaireStatusInfo ? previousQuestionnaireStatusInfo.HasResult : false;

        currentEditedAppointment = currentEditedAppointment.set(
            "Questionnaire",
            (isFromCutAppointment && isSameDay && hasSubmittedQuestionnaire)
                ? previousQuestionnaireStatusInfo
                : previousQuestionnaireStatusInfo?.newInstance()
        );

        return currentEditedAppointment;
    }

    private onPrintLabel(request: LocalEvent, store: CalendarStore): void {
        const date = store.appointmentEditModel.get("StartTime");
        const employeeId = store.appointmentEditModel.get("AppointmentIntervenor").ContactFacetId;

        const name = store.GetPatientNameForPrinting();
        const siteId = store.appointmentEditModel.get("SelectedSiteId");

        store.calendarActions.PrintAppointmentLabel(employeeId, name, date, siteId);
    }

    private onCreatePatientFile(request: LocalEvent, store: CalendarStore): void {
        store.appointmentEditModel = store.appointmentEditModel
            .set("IsNewPatientCreationMode", true)
            .set("SelectedPatientId", null)
            .set("PatientSearchString", "");

        store.SetDefaultPatientModel();
    }

    private onLinkPatientPortal(request: LocalEvent, store: CalendarStore): void {
        var patientProfileId = request.Get<Guid>("patientProfileId");

        // call action to fetch patient profile from portal
        store.appointmentEditModel = store.appointmentEditModel.set("IsLoadingPatientProfileFromPortal", true);
        store.calendarActions.LoadPortalPatientProfile(patientProfileId);

        store.appointmentEditModel = store.appointmentEditModel.set("IsLinkPatientPortalMode", true);
        store.appointmentEditModel = store.appointmentEditModel.set("SelectedPatientId", null);
    }

    private onCancelLinkPatientPortal(request: LocalEvent, store: CalendarStore): void {
        store.SetDefaultPatientModel();
        store.appointmentEditModel = store.appointmentEditModel.set("IsLoadingPatientProfileFromPortal", false);
        store.appointmentEditModel = store.appointmentEditModel.set("SelectedPatientId", null);
        store.appointmentEditModel = store.appointmentEditModel.set("IsLinkPatientPortalMode", false);
    }

    private onLinkPatientPortal_PatientCreatedOrAttached(request: LocalEvent, store: CalendarStore): void {
        store.appointmentEditModel = store.appointmentEditModel.set("IsLoadingPatientProfileFromPortal", false);
        store.appointmentEditModel = store.appointmentEditModel.set("IsLinkPatientPortalMode", false);

        store.calendarActions.LoadSelectedAppointment(store.calendarModel);
    }

    private onCompleteRecall(request: LocalEvent, store: CalendarStore): void {
        let recallId = request.Get<string>("recallId");
        store.calendarActions.CompletePatientRecall(store, recallId);
    }

    private newPatient_Cancel(request: LocalEvent, store: CalendarStore): void {
        store.SetDefaultPatientModel();
        store.appointmentEditModel = store.appointmentEditModel.set("IsLoadingPatientProfileFromPortal", false);
        store.appointmentEditModel = store.appointmentEditModel.set("SelectedPatientId", null);
        store.appointmentEditModel = store.appointmentEditModel.set("IsNewPatientCreationMode", false);
    }

    private newPatient_Save(request: LocalEvent, store: CalendarStore): void {
        let patientModel: IPatientCreationModel = request.Get<IPatientCreationModel>("patientModel");
        store.calendarActions.CreateNewPatient(patientModel);

        store.appointmentEditModel = store.appointmentEditModel.set("IsNewPatientCreationMode", false);
    }

    private cancelPortalPatientFetch(request: LocalEvent, store: CalendarStore): void {
        store.patientCreationModel = Immutable.fromJS(PatientHelper.getDefaultPatientCreationModel());
        store.appointmentEditModel = store.appointmentEditModel.set("IsLoadingPatientProfileFromPortal", false);
    }

    private duplicateAssociatePatient(request: LocalEvent, store: CalendarStore): void {
        var selectedPerson = request.Get<Person>("person");
        if (selectedPerson != null) {
            var valueToSend = new PersonDropdownItem();
            valueToSend.Item = selectedPerson;
            request.AddItem("value", valueToSend);
            this.onPatientChange(request, store);
        }
    }

    private isSendNotificationsToAllPersonalContactChecked(request: LocalEvent, store: CalendarStore): void {
        const checked = request.Get<boolean>("checked");

        store.appointmentEditModel = store.appointmentEditModel
            .set("SendToAllPersonalContacts", checked);
    }

    private isContactPointNotificationChecked(request: LocalEvent, store: CalendarStore): void {
        let checked = false;
        let contactPointId = null;
        let target = request.Get<number>("target");
        let contactPointNotificationList = store.appointmentEditModel.get("ContactPointNotificationList");
        let patient = calendarStore.appointmentEditModel.get("SelectedPatient")?.get(0);

        switch (target) {
            case CheckboxTarget.Myle_Patient_Appointment_CellNotification:
                const cell = request.Get<PhoneNumber>("item");
                contactPointId = cell.ContactPoint_id;
                checked = !cell.isSelectedForNotification;

                patient.Phones.mutate(
                    phone => phone.isSelectedForNotification = !phone.isSelectedForNotification,
                    phone => phone.ContactPoint_id === contactPointId
                );
                break;
            case CheckboxTarget.Myle_Patient_Appointment_EmailNotification:
                const email = request.Get<Email>("item");
                contactPointId = email.ContactPoint_id;
                checked = !email.isSelectedForNotification;

                patient.Emails.mutate(
                    email => email.isSelectedForNotification = !email.isSelectedForNotification,
                    email => email.ContactPoint_id === contactPointId
                );
                break;
            case CheckboxTarget.Myle_Patient_Appointment_RepresentativeEmailNotification:
                const representativeRemail = request.Get<Email>("item");
                contactPointId = representativeRemail.ContactPoint_id;
                checked = request.Get<boolean>("checked");

                patient.Relationships = patient.Relationships.mutate(
                    relationship => {
                        relationship.Emails = relationship.Emails.mutate(email => email.isSelectedForNotification = checked, p => p.ContactPoint_id == contactPointId);
                        return relationship;
                    },
                    relationship => relationship.Emails.any(email => email.ContactPoint_id == contactPointId)
                );
                break;
            case CheckboxTarget.Myle_Patient_Appointment_RepresentativeCellNotification:
                const representativeCell = request.Get<Email>("item");
                contactPointId = representativeCell.ContactPoint_id;
                checked = request.Get<boolean>("checked");

                patient.Relationships = patient.Relationships.mutate(
                    relationship => {
                        relationship.PhoneNumbers = relationship.PhoneNumbers.mutate(phone => phone.isSelectedForNotification = checked, p => p.ContactPoint_id == contactPointId);
                        return relationship;
                    },
                    relationship => relationship.PhoneNumbers.any(phone => phone.ContactPoint_id == contactPointId)
                );
                break;
            default:
                break;
        }

        contactPointNotificationList = checked
            ? contactPointNotificationList.push(contactPointId)
            : contactPointNotificationList.filterImmutable(x => x != contactPointId);

        let notifyPatientChecked = patient.Phones.some(phone => phone.isSelectedForNotification)
            || patient.Emails.some(email => email.isSelectedForNotification)
            || patient.Relationships
                .filter(rel => rel.IsRepresentative)
                .some(rel => rel.Emails.any(email => email.isSelectedForNotification) || rel.PhoneNumbers.any(phone => phone.isSelectedForNotification));

        store.appointmentEditModel = store.appointmentEditModel
            .set("ContactPointNotificationList", contactPointNotificationList)
            .set("SelectedPatient", Immutable.List([patient]))
            .set("NotifyPatient", store.appointmentEditModel.get("NotifyPatient") || (!store.appointmentEditModel.get("Questionnaire") && notifyPatientChecked));

        store.appointmentEditModel = store.appointmentEditModel.set("SendToAllPersonalContacts", !notifyPatientChecked);
    }

    private onQuestionnaireChange(request: LocalEvent, store: CalendarStore): void {
        let val = request.Get<QuestionnaireStatusInfo>("questionnaire");

        store.appointmentEditModel = store.appointmentEditModel.set("Questionnaire", val);
        store.setNotificationsByNotifyPatientStatus(!!val || store.appointmentEditModel.get("NotifyPatient"));
    }

    private onQuestionnaireClick(request: LocalEvent, store: CalendarStore): void {
        let showQuestionnaire = request.Get<boolean>("showQuestionnaire");

        store.appointmentEditModel = store.appointmentEditModel
            .set("ShowQuestionnaire", showQuestionnaire);
    }

    private onQuestionnaireSubmitted(request: LocalEvent, store: CalendarStore): void {
        let result = request.Get<boolean>("result");
        let questionnaire = store.appointmentEditModel.get("Questionnaire");

        questionnaire.Result = result;
        store.appointmentEditModel = store.appointmentEditModel
            .set("Questionnaire", questionnaire)
            .set("ShowQuestionnaire", false);

        let appointments = store.calendarModel.get("AppointmentsDisplay").toArray();
        appointments.forEach(x => {
            if (x.AppointmentId === questionnaire.AppointmentId)
                x.QuestionnaireStatusInfo = questionnaire;
        });
        store.calendarModel = store.calendarModel.set("AppointmentsDisplay", Immutable.List(appointments));

        store.EmitChangeToListeners();
    }

    private onLinkThirdPartyPatient(request: LocalEvent, store: CalendarStore): void {
        store.appointmentEditModel = store.appointmentEditModel
            .set("IsLoadingThirdPartyPatientData", true)
            .set("IsLinkThirdPartyPatientMode", true)
            .set("SelectedPatientId", null);

        store.calendarActions.LoadAppointmentExternalPatientInfo(request.Get<string>("patientSnapshotId"));
    }

    private onLinkThirdPartyPatientSuccess(request: LocalEvent, store: CalendarStore): void {
        this.onLinkThirdPartyPatientCancel(request, store);

        store.calendarActions.LoadSelectedAppointment(store.calendarModel);
    }

    private onLinkThirdPartyPatientCancel(request: LocalEvent, store: CalendarStore): void {
        store.appointmentEditModel = store.appointmentEditModel
            .set("IsLoadingThirdPartyPatientData", false)
            .set("IsLinkThirdPartyPatientMode", false);
    }

    private setOntarioEnrollmentPatientBanner(request: LocalEvent, store: CalendarStore): void {
        const enrollmentStatus = request.Get<OntarioPatientEnrollmentModel>("enrollmentStatus");
        const patientModel = request.Get<MyleModelsPatientPatient>("patient");

        if (patientModel) {
            patientModel.setOntarioPatientEnrollmentModel(enrollmentStatus);

            // change info in patient banner
            store.patientBannerModel = store.patientBannerModel.set("Model", patientModel);
        }
    }

    private onPrintCertificate(request: LocalEvent, store: CalendarStore): void {
        const appointment = store.appointmentEditModel.get("Appointment");
        const appointmentDate = store.appointmentEditModel.get("StartTime");
        const siteId = store.appointmentEditModel.get("SelectedSiteId");
        const patient = store.appointmentEditModel.get("SelectedPatient").first();

        if (patient)
            store.calendarActions.PrintAppointmentCertificate(patient.ContactId, null, appointmentDate, siteId);
        else if (appointment.IsSharedWithPortal && appointment.ExternalId)
            store.calendarActions.PrintAppointmentCertificate(null, appointment.ExternalId, appointmentDate, siteId);
        else if (!IsNullOrWhiteSpace(store.appointmentEditModel.get("PatientSearchString")))
            store.calendarActions.PrintAppointmentCertificate(null, null, appointmentDate, siteId, store.appointmentEditModel.get("PatientSearchString"));
    }

    private onOpen(request: LocalEvent, store: CalendarStore): void {
        const patient = store.appointmentEditModel.get("SelectedPatient").first();

        store.calendarModel = store.calendarModel.set("IsEditAppointmentDialogVisible", false);
        if (patient)
            patientStore.setActivePatientUI(patient.ContactId);
    }
}

export { AppointmentEditHandler };
